<ion-content>
  <ion-grid class="constrained-content">
    <ion-row>
      <ion-col size-md="4" size="12" class="settings-title-section">
        <h1><ion-icon name="logo-slack"></ion-icon>Slack Settings</h1>
        <div class="subtitle" style="opacity: 1">
          <span *ngIf="slackEnabled">Customize your Slack integration</span>
          <span *ngIf="!slackEnabled">Install the app for Slack to start using Unthread</span>
          <div style="margin-top: 15px">
            <a *ngIf="!slackEnabled || !primaryTeam" (click)="connectSlack()">
              <img
                alt="Add to Slack"
                height="40"
                width="139"
                src="https://platform.slack-edge.com/img/add_to_slack.png"
                srcset="
                  https://platform.slack-edge.com/img/add_to_slack.png    1x,
                  https://platform.slack-edge.com/img/add_to_slack@2x.png 2x
                "
              />
            </a>
          </div>
        </div>
      </ion-col>
      <ion-col size="12" size-md="8" *ngIf="slackEnabled">
        <ion-row>
          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title">
                <h3>Channel intake settings</h3>
              </ion-card-title>
              <ion-list>
                <app-intake-settings
                  [config]="defaultChannelIntakeSettings"
                  (didConfigChange)="onIntakeSettingsChange($event)"
                ></app-intake-settings>
              </ion-list>
            </ion-card>
          </ion-col>
          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title">
                <h3>Channel settings</h3>
              </ion-card-title>
              <ion-list>
                <ion-item>
                  <ion-label>
                    <h3>Automatically track conversations in connected channels</h3>
                    <p>Create tickets from new messages from customers.</p>
                  </ion-label>
                  <label class="switch" slot="end">
                    <input type="checkbox" [(ngModel)]="enableAutomatedTicketing" />
                    <span class="slider"></span>
                  </label>
                </ion-item>
                <ion-item *ngIf="enableAutomatedTicketing">
                  <ion-label>
                    <h3>Bot message triggering</h3>
                    <p>Track incoming messages from bots and apps as new conversations.</p>
                  </ion-label>
                  <label class="switch" slot="end">
                    <input type="checkbox" [(ngModel)]="isBotEnabled" />
                    <span class="slider"></span>
                  </label>
                </ion-item>
                <ion-item *ngIf="enableAutomatedTicketing">
                  <ion-label>
                    <h3>Group top-level messages that arrive within time period</h3>
                    <p>This will merge top-level messages into a single ticket.</p>
                  </ion-label>
                  <ion-select slot="end" interface="popover" [(ngModel)]="replyTimeoutMinutes" class="select-outline">
                    <ion-select-option [value]="0"> Never </ion-select-option>
                    <ion-select-option [value]="5"> 5 minutes </ion-select-option>
                    <ion-select-option [value]="10"> 10 minutes </ion-select-option>
                    <ion-select-option [value]="15"> 15 minutes </ion-select-option>
                    <ion-select-option [value]="30"> 30 minutes </ion-select-option>
                    <ion-select-option [value]="45"> 45 minutes </ion-select-option>
                    <ion-select-option [value]="60"> 1 hour </ion-select-option>
                    <ion-select-option [value]="120"> 2 hours </ion-select-option>
                    <ion-select-option [value]="180"> 3 hours </ion-select-option>
                    <ion-select-option [value]="240"> 4 hours </ion-select-option>
                    <ion-select-option [value]="300"> 5 hours </ion-select-option>
                    <ion-select-option [value]="360"> 6 hours </ion-select-option>
                    <ion-select-option [value]="720"> 12 hours </ion-select-option>
                    <ion-select-option [value]="1440"> 24 hours </ion-select-option>
                    <ion-select-option [value]="-1"> Always </ion-select-option>
                  </ion-select>
                </ion-item>
                <ion-item *ngIf="enableAutomatedTicketing">
                  <ion-label>
                    <h3>Auto-assign to tagged users</h3>
                    <p>If a message tags a specific user, assign the new ticket to that user.</p>
                  </ion-label>
                  <label class="switch" slot="end">
                    <input type="checkbox" [(ngModel)]="assignToTaggedUserEnabled" />
                    <span class="slider"></span>
                  </label>
                </ion-item>
                <ion-item>
                  <ion-label>
                    <h3>Auto-assign to first responder</h3>
                    <p>Assign new tickets to the first agent who responds.</p>
                  </ion-label>
                  <label class="switch" slot="end">
                    <input type="checkbox" [(ngModel)]="assignToFirstResponderEnabled" />
                    <span class="slider"></span>
                  </label>
                </ion-item>
              </ion-list>
            </ion-card>
            <div class="settings-learn-more">
              <a href="https://docs.unthread.io/account-setup/tracking-convo" target="_blank">
                <ion-icon name="book-outline"></ion-icon>
                Learn more about automatic conversation tracking
              </a>
            </div>
          </ion-col>
          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title">
                <h3>Ticket submission modal</h3>
                <div class="subtitle">
                  Customize the appearance of the ticket submission modal that can be accessed via channel tracker,
                  global shortcuts, and app home.
                </div>
              </ion-card-title>
              <ion-list>
                <ion-item>
                  <ion-label position="stacked">
                    <h3>Custom title for modal (optional)</h3>
                  </ion-label>
                  <ion-input
                    class="full-width-input"
                    [(ngModel)]="customTokens['CREATE_CONVERSATION_MODAL_TITLE']"
                    placeholder="Create Conversation"
                    maxlength="25"
                  ></ion-input>
                </ion-item>

                <ion-item>
                  <ion-label position="stacked">
                    <h3>Custom subtitle for modal (optional)</h3>
                  </ion-label>
                  <div style="margin-left: -15px">
                    <app-slack-text-editor
                      [content]="customTokens['CREATE_CONVERSATION_MODAL_SUBTITLE']"
                      style="width: 100%"
                      (contentDidChange)="onModalSubtitleChange($event)"
                      [projectId]="undefined"
                      [hideCodeblock]="true"
                      [hideVariable]="true"
                      [hideQuote]="true"
                      [isRichText]="false"
                      [placeholder]="'Fill out ticket details below'"
                    >
                    </app-slack-text-editor>
                  </div>
                </ion-item>
                <ion-item>
                  <ion-label position="stacked">
                    <h3>Custom label for ticket type selector (optional)</h3>
                  </ion-label>
                  <ion-input
                    class="full-width-input"
                    [(ngModel)]="customTokens['TICKET_TYPE_LABEL']"
                    placeholder="Ticket type"
                    maxlength="75"
                  ></ion-input>
                </ion-item>
                <ion-item>
                  <ion-label position="stacked">
                    <h3>Custom placeholder for ticket type selector (optional)</h3>
                  </ion-label>
                  <ion-input
                    class="full-width-input"
                    [(ngModel)]="customTokens['TICKET_TYPE_PLACEHOLDER']"
                    placeholder="Select a ticket type"
                    maxlength="75"
                  ></ion-input>
                </ion-item>
              </ion-list>
            </ion-card>
          </ion-col>
          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title">
                <h3>Slack shortcut for ticket submission</h3>
                <div class="subtitle">
                  Configure settings for slash command or global shortcut to create a ticket from anywhere in Slack
                </div>
              </ion-card-title>
              <ion-list>
                <ion-item>
                  <ion-label>
                    <h3>Disable direct ticket creation</h3>
                    <p>Prevent users from using the slack global shortcut to create a ticket.</p>
                  </ion-label>
                  <label class="switch" slot="end">
                    <input type="checkbox" [(ngModel)]="slackInboxConfig.disableDirectTicketCreation" />
                    <span class="slider"></span>
                  </label>
                </ion-item>
                <ion-item *ngIf="!slackInboxConfig.disableDirectTicketCreation">
                  <ion-label>
                    <h3>Show project selector first</h3>
                    <p>
                      First show the project selector instead of the ticket type selector in the ticket creation form.
                    </p>
                  </ion-label>
                  <label class="switch" slot="end">
                    <input type="checkbox" [(ngModel)]="slackInboxConfig.showProjectSelectorFirstOnTicketCreation" />
                    <span class="slider"></span>
                  </label>
                </ion-item>
                <ion-item *ngIf="!slackInboxConfig.disableDirectTicketCreation">
                  <ion-label text-wrap>
                    <h3>Hide projects and project-level ticket types</h3>
                    <p>
                      When enabled, all projects and their ticket types will not appear in the Slack ticket creation
                      shortcut by default. Individual projects can override this setting if explicitly set.
                    </p>
                  </ion-label>
                  <label class="switch" slot="end">
                    <input type="checkbox" [(ngModel)]="slackInboxConfig.defaultHideProjectsInDirectTicketCreation" />
                    <span class="slider"></span>
                  </label>
                </ion-item>
              </ion-list>
            </ion-card>
          </ion-col>
          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title">
                <h3>Bot DM Ticketing</h3>
                <div class="subtitle">Enable DMs to the Unthread bot to create internal tickets</div>
              </ion-card-title>

              <ion-list>
                <ion-item>
                  <ion-label text-wrap>
                    <h3>Enable</h3>
                  </ion-label>
                  <label class="switch" slot="end">
                    <input type="checkbox" [(ngModel)]="advancedInternalTicketingEnabled" />
                    <span class="slider"></span>
                  </label>
                </ion-item>
                <ion-item [hidden]="!advancedInternalTicketingEnabled || authService.tenant.accountsEnabled">
                  <ion-label>
                    <h3>Default customer to assign tickets created through DMs to the Unthread bot</h3>
                    <p>This can be overriden per ticket type.</p>
                  </ion-label>
                  <ion-chip
                    mode="ios"
                    class="select-chip select-outline"
                    [outline]="true"
                    (click)="showCustomerOptions()"
                    [disabled]="isLoading"
                  >
                    <ion-label>
                      {{ advancedInternalTicketingDefaultCustomer?.name ?? 'None' }}
                      <ion-icon name="chevron-down-outline" class="icon-padded-left"></ion-icon>
                    </ion-label>
                  </ion-chip>
                </ion-item>
                <ion-item *ngIf="advancedInternalTicketingEnabled">
                  <ion-label>Ticket intake mode</ion-label>
                  <ion-select slot="end" interface="popover" [(ngModel)]="botDmIntakeMode" class="select-outline">
                    <ion-select-option [value]="INTAKE_MODES.BOT_TRIAGE">
                      {{ INTAKE_MODE_LABELS[INTAKE_MODES.BOT_TRIAGE] }}
                    </ion-select-option>
                    <ion-select-option [value]="INTAKE_MODES.FORM">
                      {{ INTAKE_MODE_LABELS[INTAKE_MODES.FORM] }}
                    </ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-list>
            </ion-card>
            <div class="settings-learn-more">
              <a href="https://docs.unthread.io/ai/slack-bot" target="_blank">
                <ion-icon name="book-outline"></ion-icon>
                Learn more about the bot DM ticketing
              </a>
            </div>
          </ion-col>
          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title">
                <div>
                  <h3>Away Status Tracking</h3>
                  <div class="subtitle">Configure auto-tracking of support rep status</div>
                </div>
              </ion-card-title>
              <ion-list>
                <ion-item>
                  <ion-label>
                    <h3>Use status emojis</h3>
                  </ion-label>
                  <label class="switch" slot="end">
                    <input type="checkbox" [(ngModel)]="slackAwaySettings.useStatus" />
                    <span class="slider"></span>
                  </label>
                </ion-item>
                <ion-item>
                  <ion-label text-wrap>
                    <ion-chip
                      outline
                      color="dark"
                      *ngFor="let awayEmoji of slackAwaySettings.awayEmojis; let i = index"
                      (click)="deleteAwayEmoji(i)"
                    >
                      <ion-label>{{ awayEmoji }}</ion-label>
                      <ion-icon name="close-circle"></ion-icon>
                    </ion-chip>
                    <ion-chip [outline]="true" color="primary" class="btn-small" (click)="openEmojiPicker('', $event)">
                      + Add
                    </ion-chip>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-label>
                    <h3>Use Do Not Disturb settings</h3>
                    <div *ngIf="!hasReadDndScope" class="subtitle">
                      Reconnect Slack in order to enable this setting.
                    </div>
                  </ion-label>
                  <label class="switch" slot="end">
                    <input type="checkbox" [(ngModel)]="slackAwaySettings.useDnd" [disabled]="!hasReadDndScope" />
                    <span class="slider"></span>
                  </label>
                </ion-item>
              </ion-list>
            </ion-card>
          </ion-col>

          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title">
                <h3>Slack Workspaces</h3>
                <div class="subtitle">Connect additional workspaces like a Slack community.</div>
              </ion-card-title>

              <ion-card-content>
                <ion-card class="outline-card" style="margin: 10px 0" *ngFor="let team of connectedTeams">
                  <ion-card-content class="flex-space-between">
                    <ion-label text-wrap style="font-weight: 500; font-size: 1rem; display: flex; align-items: center">
                      {{ team.name }}
                      <ion-badge color="success" *ngIf="team.isPrimary" style="margin-left: 5px">Primary</ion-badge>
                    </ion-label>
                    <div class="flexed-align-center">
                      <ion-button color="danger" fill="clear" (click)="disconnectSlack(team.id)" class="btn-small">
                        <ion-icon name="close-outline" class="padded-icon"></ion-icon>
                        Disconnect
                      </ion-button>
                      <ion-button fill="clear" (click)="connectSlack(!team.isPrimary, team.id)" class="btn-small">
                        <ion-icon name="sync-outline" class="padded-icon"></ion-icon>
                        Reconnect
                      </ion-button>
                    </div>
                  </ion-card-content>
                </ion-card>
                <div style="margin-top: 15px">
                  <p>Connect another Slack workspace to your account:</p>
                  <a (click)="connectSlack(!!connectedTeams.length)">
                    <img
                      alt="Add to Slack"
                      height="40"
                      width="139"
                      src="https://platform.slack-edge.com/img/add_to_slack.png"
                      srcset="
                        https://platform.slack-edge.com/img/add_to_slack.png    1x,
                        https://platform.slack-edge.com/img/add_to_slack@2x.png 2x
                      "
                    />
                  </a>
                </div>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer *ngIf="slackEnabled">
  <ion-toolbar class="constrained-content">
    <ion-button color="success" (click)="save()" class="save-button" [disabled]="!initialized"
      >Save changes
    </ion-button>
  </ion-toolbar>
</ion-footer>
